import actions from './actions';
import { createReducer } from '../../../../helpers/reducer';
import { keyBy } from '../../../../helpers/core';

const initState = {
  editForm: null,
  loading: false,
  formInfo: {},
  isReinstateRequestPending: false,
  isSuspensionModalShown: false,
};

const initialSuspensionData = {
  admin_suspension_action_reason_id: undefined,
  duration: undefined,
  comment: '',
};

function validate(/* attr, value */) {
  return '';
}

function onCreate(state) {
  const propsArray = Object.keys(initialSuspensionData);
  const editForm = keyBy(
    propsArray,
    prop => prop,
    prop => ({
      name: prop,
      value: initialSuspensionData[prop],
      error: '',
      touched: false,
    }),
  );

  return {
    ...state,
    editForm,
  };
}

function onEdit(state, { payload }) {
  const { comment, duration, suspension_reason } = payload;
  const suspensionData = {
    admin_suspension_action_reason_id: suspension_reason.id,
    duration: duration.id,
    comment,
  };
  const propsArray = Object.keys(suspensionData);
  const editForm = keyBy(
    propsArray,
    prop => prop,
    prop => ({
      name: prop,
      value: suspensionData[prop],
      error: '',
      touched: false,
    }),
  );

  return {
    ...state,
    editForm,
  };
}

function onChangeProperty(state, { payload }) {
  const { attr, value } = payload;
  const { editForm } = state;

  editForm[attr] = {
    value,
    error: validate(attr, value),
    name: attr,
    touched: true,
  };

  return {
    ...state,
    editForm: {
      ...editForm,
    },
  };
}

function onLoadFormDataSuccess(state, { payload }) {
  const { data: formInfo } = payload;

  return {
    ...state,
    formInfo,
  };
}

function onToggleSuspensionModal(state) {
  const { isSuspensionModalShown } = state;

  return {
    ...state,
    isSuspensionModalShown: !isSuspensionModalShown,
  };
}

function onReinstate(state) {
  return {
    ...state,
    isReinstateRequestPending: true,
  };
}

function onReinstateSuccess(state) {
  return {
    ...state,
    isReinstateRequestPending: false,
  };
}

export default createReducer(initState, {
  [actions.CREATE]: onCreate,
  [actions.EDIT]: onEdit,
  [actions.REINSTATE]: onReinstate,
  [actions.REINSTATE_SUCCESS]: onReinstateSuccess,
  [actions.LOAD_FORM_DATA_SUCCESS]: onLoadFormDataSuccess,
  [actions.CHANGE_PROPERTY]: onChangeProperty,
  [actions.TOGGLE_SUSPENSION_MODAL]: onToggleSuspensionModal,
});
